import React, { Component } from 'react'
import { Grid, Button, IconButton, Box } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import useStyles from './styles/FooterStyle'
import withWidth, { isWidthDown } from '@material-ui/core/withWidth'
import {ReactComponent as FacebookLogo} from '../../assets/Facebook.svg'
import {ReactComponent as InstagramLogo} from '../../assets/Instagram.svg'
import {ReactComponent as RssLogo} from '../../assets/Rss.svg'
import {ReactComponent as TwitterLogo} from '../../assets/Twitter.svg'
import {ReactComponent as TiktokLogo} from '../../assets/Tiktok.svg'
import {ReactComponent as YoutubeLogo} from '../../assets/Youtube.svg'
import {ReactComponent as LinkedinLogo} from '../../assets/Linkedin.svg'
import { openLinkInNewTab, openLinkInSameTab } from '../../services/Utils'

class Footer extends Component {

  getSocialLogoImage(type) {
    switch(type) {
      case "facebook":
        return <FacebookLogo/>
      case "rss":
        return <RssLogo />
      case "instagram":
        return <InstagramLogo />
      case "twitter":
        return <TwitterLogo />
      case "tiktok":
        return <TiktokLogo />
      case "youtube":
        return <YoutubeLogo />
      case "linkedin":
        return <LinkedinLogo />
      default:
        return null;
    }
  }

  renderLinksMobile() {
    const classes = this.props.classes
    return (
      <Grid item container className={`${classes.linksContainerMobile}`} direction='row' alignItems='flex-start' justify='space-evenly' sm={12}>

        {/*Render right column (elements with even index)*/}
        <Grid item container className={`${classes.linksColumnMobile}`} alignItems='flex-start' direction='column'>
          {this.props.links.filter((link,index) => index % 2 === 0).map((link,index) => {
            return (
              <Button className={`${classes.linkText}`} onClick={() => {openLinkInSameTab(link.link)}}>
                <Box className={`${classes.linkText} footer-link-text`} >
                  {link.name}
                </Box>
              </Button>
            )
          }
          )}
        </Grid>

        {/* Render right column (elements with odd index) */}
        <Grid item container className={`${classes.linksColumnMobile}`} alignItems='flex-start' justify='flex-start' direction='column'>
          {this.props.links.filter((link,index) => index % 2 === 1).map((link,index) => {
            return (
              <Button className={`${classes.linkText} footer-link-text`} onClick={() => {openLinkInSameTab(link.link)}}>
                <Box className={`${classes.linkText} footer-link-text`} >
                  {link.name}
                </Box>
              </Button>
            )
          }
          )}
        </Grid>
      </Grid>
    )
  }

  renderLinksDesktop() {
    const classes = this.props.classes
    return (
      <Grid item container className={`${classes.linksContainerDesktop}`}>
        {this.props.links.map((link,index) => {
          return (
            <Grid key={index} className={classes.linksItem}>
              <Button className={classes.linksButton} onClick={() => {openLinkInSameTab(link.link)}}>
                <Box className={`${classes.linkText} footer-link-text`} >
                  {link.name}
                </Box>
              </Button>
            </Grid>
          )
        })}
      </Grid>
    )
  }

  renderSocialLinks() {
    const classes = this.props.classes
    return (
      <Grid item container className={`${classes.socialLinksButtonsContainer}`}>
        {Object.keys(this.props.socialLinks).map((socialPlatform,index) => {
          const link = this.props.socialLinks[socialPlatform]
          if (link) {
            return (
              <Grid item key={index} className={`${classes.socialLinksButtonItem} footer-social-links-button-item`}>
                <IconButton onClick={() => {openLinkInNewTab(link)}} className={`${classes.socialLinksButton}`}>
                  {this.getSocialLogoImage(socialPlatform)}
                </IconButton>
              </Grid>
            )
          } else {
            return null
          }
        })}
      </Grid>
    )
  }

  renderPoweredBy() {
    const classes = this.props.classes
    return (
      <Grid item container className={`${classes.poweredByContainer} powered-by-container`}>
        <Box className={`${classes.poweredByText} powered-by-text`} >
          Powered by Minute Media © All rights reserved
        </Box>
      </Grid>
    )
  }

  render() {
    const isMobile = isWidthDown('sm', this.props.width);
    const classes = this.props.classes
    const hasSocialLinks = this.props.socialLinks && Object.values(this.props.socialLinks).some(socialLink => !!socialLink)
    return (
      <Grid container direction="column" className={`${classes.container} footer-container`}>
        <Grid item className={`${classes.thinSeparator} footer-thin-top-separator`}>
          {/* This is the top separator of the footer */}
        </Grid>
        <Grid item container direction='column' justify='center' alignItems='center' className={classes.footerLinksTitleContainer}>
          <Grid item>
            <Box className={`${classes.titleText} footer-section-title`} >
              LINKS
            </Box>
          </Grid>
        </Grid>

        {isMobile ? this.renderLinksMobile() : this.renderLinksDesktop()}
        {hasSocialLinks && (
          <Grid container item className={classes.socialLinksContainer}>
            <Grid item container className={`${classes.separator} footer-separator`}/>
            <Grid item>
              <Box className={`${classes.titleText} footer-section-title`} >
                FOLLOW US
              </Box>
            </Grid>
          </Grid>
        )}
        {hasSocialLinks && this.renderSocialLinks()}
        {this.renderPoweredBy()}
      </Grid>
    )
  }
}

export default withStyles(useStyles)(withWidth()(Footer))
